import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../mass-upload-form-control.component';
import { EXCEL_PERSON_TYPES, MassUploadStateFormMap } from '../../../../producer/mass-upload-grid/interfaces/mass-upload-grid.interface';
import { UntypedFormGroup } from '@angular/forms';

@FormComponentLookup('mass-upload-grid-control-plan-region')
@Component({
  selector: 'app-mass-upload-plan-region-form-control',
  templateUrl: '../mass-upload-form-control.component.html',
  styleUrl: '../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadPlanRegionFormControlComponent extends MassUploadFormControlComponent {

  isSubscriber = false;

  ngOnInit() {
    super.ngOnInit();
            
    // If we are a dependent, we want this value to be intialized and updated only via the subscriber's value as the dependent should match the sub's region
    this.isSubscriber = this.mugDataHelperService.getPersonTypeByStateId(this.stateId) === EXCEL_PERSON_TYPES.SUBSCRIBER;
    if (!this.isSubscriber) {
      this.updateSelfWithSubscriberValue();
      return;
    }

    let countyControl = this.getCountyControl();
    this.subscriptionGroup.push(countyControl.valueChanges.subscribe(async (countyName: string) => {
      let county = await this.getCounty();
      if (county){
        this.resetFormValue(county.region);
        this.updateDependentRegions(county.region);
      }
      else {
        this.resetFormValue(null);
        this.updateDependentRegions(null);
      }
    }));
  }

  updateDependentRegions(newRegion: string) {
    let formGroupsToCheck: MassUploadStateFormMap[] = this.mugDataHelperService.getFullFamilyFormGroupsBySubscriberStateId(this.stateId);
    for (let i = 1; i < formGroupsToCheck.length; i++) {
      let depStateId = formGroupsToCheck[i].stateId;
      let formGroup = formGroupsToCheck[i].formGroups[this.mugDataHelperService.getPlanRegionFormKey(depStateId)];
      formGroup.controls.planRegion.setValue(newRegion);
      
      this.revalidateFormGroups(formGroupsToCheck[i].formGroups);
    }
  }

  updateSelfWithSubscriberValue() {
    let subFormMap: MassUploadStateFormMap = this.mugDataHelperService.getOwnerFormMapFromStateId(this.stateId);
    this.resetFormValue(subFormMap.formGroups[this.mugDataHelperService.getPlanRegionFormKey(subFormMap.stateId)].controls.planRegion.value);
    this.revalidateFormGroups(this.parentForm);
  }

  // TODO - This validation does not actually do anything
  // The dependent row is not active and therefore does not trigger nor listen to the form stream triggers
  // In order to get immediate updates, we would need to re-initalize the row so the ptl component hooks fire
  revalidateFormGroups(formGroups) {
    Object.values(formGroups).forEach((group:UntypedFormGroup) => {
      group.updateValueAndValidity();
    });
  }
}
